// import "./styles.css";
import React, { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
  AreaChart,
  Area,
  Label,
  Dot,
  Bar,
  Cell,
  ComposedChart,
  ResponsiveContainer,
} from 'recharts';

const barColors = [
  '#f56524',
  '#1a9dff',
  '#a3c538',
  '#fcc80a',
  '#ff9800',
  '#795548',
  '#607d8b',
];

// const data = [
//   { date: '2024-03-01', 'Org A': 120, OrgB: 150, OrgC: 200 },
//   { date: '2024-03-02', 'Org A': 130, OrgB: 160, OrgC: 210 },
//   { date: '2024-03-03', 'Org A': 110, OrgB: 140, OrgC: 190 },
//   { date: '2024-03-04', 'Org A': 140, OrgB: 170, OrgC: 220 },
//   { date: '2024-03-05', 'Org A': 150, OrgB: 180, OrgC: 230 },
// ];

export default function ReactLineChart({ chartData, percent = 0 }) {
  const [showXAxisLabel, setShowXAxisLabel] = useState(true);
  const [selectedOrg, setSelectedOrg] = useState('');

  useEffect(() => {
    if (chartData && chartData.length > 29) {
      setShowXAxisLabel(false);
    }
    // const singleObj = chartData && chartData[0] ? chartData[0] : {};
    // delete singleObj?.date;
    // const organizationNames = Object.keys(singleObj);
    // setSelectedOrg(organizationNames?.[0]);
  }, [chartData]);

  const singleObj = chartData && chartData[0] ? chartData[0] : {};
  delete singleObj?.date;
  const organizationNames = Object.keys(singleObj);

  function CustomTooltip({ active, payload, label }) {
    if (active && payload) {
      return (
        <div
          style={{
            backgroundColor: '#f1c40fa1',
            padding: 10,
            color: 'black',
          }}
        >
          <span style={{ display: 'block' }}>{`${label}`}</span>
          <span>
            {percent ? 'Percentage' : 'Count'}:{' '}
            {`${payload[0].value}${percent ? '%' : ''}`}
          </span>
        </div>
      );
    }

    return null;
  }

  // Custom Y-axis Tick Renderer
  const renderCustomTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        dy={6}
        textAnchor="end"
        fill="black"
        style={{ whiteSpace: 'nowrap', fontSize: '14px' }}
      >
        {payload.value}
      </text>
    );
  };

  return (
    <>
      <select
        name="graphSelect"
        id="graphSelect"
        onChange={(e) => setSelectedOrg(e.target.value)}
      >
        <option value="">All</option>
        {organizationNames?.map((name, index) => (
          <option key={`selectOrgGraph-${index}`} value={name}>
            {name}
          </option>
        ))}
      </select>
      <ResponsiveContainer width="100%" height={430}>
        <LineChart
          data={chartData}
          margin={{ top: 20, right: 0, left: 0, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            angle={60}
            textAnchor="start"
            tick={{
              fontSize: 14,
              display: showXAxisLabel ? 'inline-block' : 'none',
            }}
            interval={0}
          />
          <YAxis />
          <Tooltip />
          {/* <Legend
            verticalAlign="top"
            align="center"
            wrapperStyle={{ transform: 'translateY(-10px)' }}
          /> */}
          {selectedOrg === '' &&
            organizationNames?.map((item, index) => (
              <Line
                key={`Line-${index}`}
                type="monotone"
                dataKey={item}
                stroke={barColors[index % barColors.length]}
                strokeWidth={2}
              />
            ))}
          {selectedOrg !== '' &&
            organizationNames?.map(
              (item, index) =>
                selectedOrg?.trim()?.toLowerCase() ===
                  item?.trim()?.toLowerCase() && (
                  <Line
                    key={`Line-${index}`}
                    type="monotone"
                    dataKey={item}
                    stroke={barColors[index % barColors.length]}
                    strokeWidth={2}
                  />
                ),
            )}

          {/* <Line
            type="monotone"
            dataKey="Org A"
            stroke="#8884d8"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="OrgB"
            stroke="#82ca9d"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="OrgC"
            stroke="#ff7300"
            strokeWidth={2}
          /> */}
        </LineChart>
      </ResponsiveContainer>

      {/* <ResponsiveContainer width="100%" height={430}>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 60 }}
        >
          <defs>
            <linearGradient id="colorvalue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="name"
            angle={60}
            textAnchor="start"
            tick={{
              fontSize: 14,
              display: 'inline-block',
            }}
            interval={0}
            // domain={[0, "auto"]}
          />

          <YAxis
            dataKey="amt"
            angle={60}
            textAnchor="start"
            tick={{
              fontSize: 14,
              display: 'inline-block',
            }}
            interval={0}
          />
          <CartesianGrid strokeDasharray="1 1" />
          <Tooltip content={CustomTooltip} wrapperStyle={{ outline: 'none' }} />
          <Area
            type="monotone"
            dataKey="uv"
            stroke="#8884d8"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
        </AreaChart>
      </ResponsiveContainer> */}
    </>
  );
}
